import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { authFetch } from "./authFetch";

import { defaultLaborSkills } from "./laborSkills";

export default function TarifeManopera({ onLoaded }) {
  const [firma, setFirma] = useState(null);
  const [rates, setRates] = useState(defaultLaborSkills);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    let active = true;
    authFetch("/comenzi/tarife-manopera").then(data => {
      if (!active) return;
      setFirma(true);
      setRates({ ...defaultLaborSkills, ...data });
      onLoaded?.(data);
    }).catch(err => { if (active) setError(err.message); });
    return () => { active = false; };
  }, [onLoaded]);
  const save = async event => {
    event.preventDefault();
    const payload = Object.fromEntries(Object.entries(rates).map(([key, value]) => [key, key.startsWith("label_") ? String(value).trim() : Number(value)]));
    if (Object.values(rates).some(value => value === "") || Object.entries(payload).some(([key, value]) => key.startsWith("label_") ? !value : !Number.isFinite(value) || value < 0)) {
      setError("Completează denumirile și tarife pozitive sau zero."); return;
    }
    setSaving(true); setError(""); setNotice("");
    try {
      const data = await authFetch("/comenzi/tarife-manopera", { method: "PUT", body: JSON.stringify(payload) });
      setRates({ ...defaultLaborSkills, ...data }); onLoaded?.(data);
      setNotice("Tarifele au fost salvate. Se folosesc la următoarea alegere a unei operații în deviz.");
    } catch (err) { setError(err.message || "Tarifele nu au putut fi salvate."); }
    finally { setSaving(false); }
  };
  return <Form onSubmit={save} className="border rounded p-3 mb-4">
    <h5>Niveluri și tarife manoperă</h5>
    <p className="text-muted">Denumirile sunt editabile. Prețuri în lei/oră, fără TVA. Valoare manoperă = ore × tarif nivel. Rândurile existente își păstrează valorile.</p>
    {error && <Alert variant="danger">{error}</Alert>}
    {notice && <Alert variant="success">{notice}</Alert>}
    <Row className="g-3 align-items-end">
      {[1, 2, 3, 4].map(skill => { const key = `tarif_skill${skill}`; return (
        <Col md={3} key={key}><Form.Group controlId={`label_skill${skill}`}><Form.Label>Denumire nivel {skill}</Form.Label><Form.Control required maxLength={60} disabled={!firma || saving} value={rates[`label_skill${skill}`]} onChange={event => setRates(prev => ({ ...prev, [`label_skill${skill}`]: event.target.value }))} /></Form.Group><Form.Group controlId={key}>
          <Form.Label>Tarif nivel {skill} (lei/oră)</Form.Label>
          <Form.Control type="number" min="0" step="0.0001" required disabled={!firma || saving} value={rates[key]}
            onChange={event => { setRates(prev => ({ ...prev, [key]: event.target.value })); setNotice(""); }} />
        </Form.Group></Col>); })}
      <Col><Button type="submit" disabled={!firma || saving}>{saving ? "Se salvează…" : "Salvează tarife"}</Button></Col>
    </Row>
  </Form>;
}
